import { render, staticRenderFns } from "./Partidos.vue?vue&type=template&id=72002c53&scoped=true"
import script from "./Partidos.vue?vue&type=script&lang=js"
export * from "./Partidos.vue?vue&type=script&lang=js"
import style0 from "./Partidos.vue?vue&type=style&index=0&id=72002c53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72002c53",
  null
  
)

export default component.exports